<template>
    <div>
        <!-- Success change -->
        <v-snackbar v-model="showchangeMessage" color="#16C96D" top role="status" aria-live="polite" aria-atomic="true" tabindex="-1">
            <v-icon dark size="25" aria-hidden="true">mdi-check</v-icon>
            <span class="font-weight-bold pl-2">{{ changeMessage }}</span>
        </v-snackbar>

        <!-- Info -->
        <v-snackbar top :color="info.color" v-model="showInfo" role="status" aria-live="polite" aria-atomic="true" tabindex="-1">
            <v-icon aria-hidden="true">{{ info.icon }}</v-icon>
            <span class="font-weight-bold pl-2">{{ info.message }}</span>
        </v-snackbar>

        <!-- DELETE USER DIALOG -->
        <v-dialog
            v-model="deleteUserQuestion"
            max-width="350px"
            role="alertdialog"
            aria-modal="true"
            aria-labelledby="delete-user-title"
            :retain-focus="false"
            @keydown.esc="deleteUserQuestion = false">
            <v-card v-focus-trap="deleteUserQuestion">
                <v-card-title
                    id="delete-user-title"
                    style="
                         {
                            text-align: center;
                        }
                    ">
                    Delete {{ selectedUser.username }}?
                </v-card-title>
                <v-card-text class="text-center">
                    <v-btn data-focus-first class="mr-3" text absolute left type="button" @click="deleteUserQuestion = false"> Nevermind </v-btn>
                    <v-btn color="primary" text type="button" @click="deleteUser()"> Yes </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>

        <AddUserDialog @close="addUserDialog = false" @createInfo="createInfo" @refreshData="fetchUser()" :company_domains="domains" :addUserDialog="addUserDialog"></AddUserDialog>

        <v-row role="region" aria-label="User actions">
            <v-col class="d-flex">
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn rounded small @click="addUserDialog = true" color="primary" class="fabicon mx-5 mt-auto" v-bind="attrs" v-on="on" type="button">
                            <v-icon dark aria-hidden="true">mdi-plus</v-icon>
                            add user
                        </v-btn>
                    </template>
                    <span>invite user</span>
                </v-tooltip>
            </v-col>

            <v-spacer></v-spacer>

            <!-- Default Group dialog -->
            <v-dialog
                v-model="showDefaultGroup"
                max-width="400"
                height="300px"
                role="dialog"
                aria-modal="true"
                aria-labelledby="default-group-title"
                :retain-focus="false"
                @keydown.esc="showDefaultGroup = false">
                <v-card v-focus-trap="showDefaultGroup">
                    <v-card-title id="default-group-title">Change Default User Rights</v-card-title>

                    <v-card-text>
                        <div v-if="$store.state.company_status == 'active' || $store.state.company_status == 'testing' || $store.state.company_status == 'free'" class="qgreycard mx-5 my-2 ml-auto">
                            <span class="lbl">
                                Research Suite
                                <v-tooltip max-width="250" color="" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2" aria-hidden="true"> mdi-help-circle-outline </v-icon>
                                    </template>
                                    <span> The selected Research Suite default user group will be assigned to any user created manually by the Admin or via the Register page! </span>
                                </v-tooltip>
                            </span>

                            <v-select
                                data-focus-first
                                dense
                                color="primary"
                                hide-details
                                rounded
                                filled
                                class="my-auto"
                                :items="groups"
                                item-text="name"
                                item-value="id"
                                return-object
                                v-model="selected_standard_group"
                                @change="changeStandardGroup"
                                aria-label="Select default Research Suite group">
                                <template v-slot:item="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item ripple v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.name }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.description }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </div>

                        <div
                            v-if="
                                $store.state.company_status_content_suite == 'active' || $store.state.company_status_content_suite == 'testing' || $store.state.company_status_content_suite == 'free'
                            "
                            class="qgreycard mx-5 my-2 ml-auto">
                            <span class="lbl">
                                Content Suite
                                <v-tooltip max-width="250" color="" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2" aria-hidden="true"> mdi-help-circle-outline </v-icon>
                                    </template>
                                    <span> The selected Content Suite default user group will be assigned to any user created manually by the Admin or via the Register page! </span>
                                </v-tooltip>
                            </span>

                            <v-select
                                dense
                                color="primary"
                                hide-details
                                rounded
                                filled
                                class="my-auto"
                                :items="cs_groups"
                                item-text="name"
                                item-value="id"
                                return-object
                                v-model="selected_standard_group_cs"
                                @change="changeStandardGroup"
                                aria-label="Select default Content Suite group">
                                <template v-slot:item="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item ripple v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.name }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.description }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </div>

                        <div
                            v-if="
                                $store.state.company_status_monitoring_suite == 'active' ||
                                $store.state.company_status_monitoring_suite == 'testing' ||
                                $store.state.company_status_monitoring_suite == 'free'
                            "
                            class="qgreycard mx-5 my-2 ml-auto">
                            <span class="lbl">
                                Monitoring Suite
                                <v-tooltip max-width="250" color="" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2" aria-hidden="true"> mdi-help-circle-outline </v-icon>
                                    </template>
                                    <span> The selected Monitoring Suite default user group will be assigned to any user created manually by the Admin or via the Register page! </span>
                                </v-tooltip>
                            </span>

                            <v-select
                                dense
                                color="primary"
                                hide-details
                                rounded
                                filled
                                class="my-auto"
                                :items="ms_groups"
                                item-text="name"
                                item-value="id"
                                return-object
                                v-model="selected_standard_group_ms"
                                @change="changeStandardGroup"
                                aria-label="Select default Monitoring Suite group">
                                <template v-slot:item="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item ripple v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.name }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.description }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </div>

                        <div
                            v-if="$store.state.company_status_ki_chat == 'active' || $store.state.company_status_ki_chat == 'testing' || $store.state.company_status_ki_chat == 'free'"
                            class="qgreycard mx-5 my-2 ml-auto">
                            <span class="lbl">
                                KI Chat
                                <v-tooltip max-width="250" color="" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2" aria-hidden="true"> mdi-help-circle-outline </v-icon>
                                    </template>
                                    <span> The selected KI Chat default user group will be assigned to any user created manually by the Admin or via the Register page! </span>
                                </v-tooltip>
                            </span>

                            <v-select
                                dense
                                color="primary"
                                hide-details
                                rounded
                                filled
                                class="my-auto"
                                :items="ki_chat_groups"
                                item-text="name"
                                item-value="id"
                                return-object
                                v-model="selected_standard_group_ki_chat"
                                @change="changeStandardGroup"
                                aria-label="Select default KI Chat group">
                                <template v-slot:item="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item ripple v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.name }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.description }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </div>

                        <div
                            v-if="$store.state.company_status_ai_suite == 'active' || $store.state.company_status_ai_suite == 'testing' || $store.state.company_status_ai_suite == 'free'"
                            class="qgreycard mx-5 my-2 ml-auto">
                            <span class="lbl">
                                AI Suite
                                <v-tooltip max-width="250" color="" top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" class="pl-0 mr-auto tooltipicon" small color="grey lightn-2" aria-hidden="true"> mdi-help-circle-outline </v-icon>
                                    </template>
                                    <span> The selected AI Suite default user group will be assigned to any user created manually by the Admin or via the Register page! </span>
                                </v-tooltip>
                            </span>

                            <v-select
                                dense
                                color="primary"
                                hide-details
                                rounded
                                filled
                                class="my-auto"
                                :items="ks_groups"
                                item-text="name"
                                item-value="id"
                                return-object
                                v-model="selected_standard_group_ks"
                                @change="changeStandardGroup"
                                aria-label="Select default AI Suite group">
                                <template v-slot:item="{ item }">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-list-item ripple v-on="on">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        {{ item.name }}
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </template>
                                        <span>{{ item.description }}</span>
                                    </v-tooltip>
                                </template>
                            </v-select>
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn rounded class="mx-auto" color="primary" dark type="button" @click="showDefaultGroup = false"> ok </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-col class="d-flex">
                <v-btn class="ml-auto mr-5" outlined color="primary" rounded type="button" @click="showDefaultGroup = true" aria-haspopup="dialog">
                    <v-icon class="mr-1" size="16px" aria-hidden="true">mdi-cog</v-icon>
                    Default User Group
                </v-btn>
            </v-col>
        </v-row>

        <v-text-field
            class="mx-5 mb-3"
            max-width="300px"
            dense
            small
            prepend-inner-icon="mdi-magnify"
            rounded
            filled
            hide-details
            v-model="search"
            label="Search user"
            :aria-describedby="'users-search-hint users-count'"
            aria-controls="user-table"></v-text-field>
        <v-chip class="ml-5 mb-3" small>{{ usersStatusText }}</v-chip>
        <p id="users-search-hint" class="sr-only">Type to filter the user list. Results update as you type.</p>
        <p id="users-count" class="sr-only" aria-live="polite">{{ usersStatusText }}</p>

        <!-- Tabelle als Region mit Label -->
        <div role="region" aria-label="User table">
            <v-data-table
                id="usertable"
                :headers="header"
                :items="user"
                :search.sync="search"
                class="elevation-0"
                max-height="500"
                item-key="searchPhrase"
                dense
                :sort-by.sync="user_sort_by"
                :sort-desc.sync="user_sort_desc">
                <!-- Loading-Zustand als Live-Region -->
                <template class="px-0" v-slot:no-data>
                    <div role="status" aria-live="polite" class="px-0">
                        <v-progress-linear class="px-0" :size="50" color="primary" :indeterminate="true"></v-progress-linear>
                        <span class="sr-only">Loading users…</span>
                    </div>
                </template>
                <template v-slot:[`header.username`]="{ header }">
                    <span :aria-sort="user_sort_by && user_sort_by[0] === 'username' ? (user_sort_desc && user_sort_desc[0] ? 'descending' : 'ascending') : 'none'">
                        <v-btn small text class="th-btn th-btn--header">
                            <span class="th-text">{{ header.text }}</span>
                        </v-btn>
                        <span class="sr-only" aria-live="polite">
                            <span v-if="user_sort_by && user_sort_by[0] === 'username' && !(user_sort_desc && user_sort_desc[0])"> (sorted in ascending order)</span>
                            <span v-else-if="user_sort_by && user_sort_by[0] === 'username' && user_sort_desc && user_sort_desc[0]"> (sorted in descending order)</span>
                        </span>
                    </span>
                </template>
                <template class="px-0" v-slot:item.username="{ item }">
                    <div class="py-3">
                        <div>{{ item.username }}</div>
                        <v-chip small>{{ item.user }}</v-chip>
                    </div>
                </template>

                <!-- Research Suite group menu -->
                <template class="px-0" v-slot:item.group_id="{ item }">
                    <v-menu top offset-y right content-class="submenu" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small text rounded color="grey darken-2" outlined type="button" aria-haspopup="menu">
                                <span v-if="item.admin">admin</span>
                                <span v-else-if="!item.research_suite">no access</span>
                                <span v-else>
                                    {{ groups[groups.findIndex((x) => item.group_id == x.id)].name }}
                                </span>
                                <v-icon size="16px" aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list rounded dense style="max-height: 300px; overflow-y: auto; font-weight: bold !important" role="menu" aria-label="Research Suite group">
                            <v-list-item class="pl-2" @click="grantAdmin(item)" role="menuitemradio" :aria-checked="String(Boolean(item.admin))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>

                            <div v-for="group in groups" :key="group.id">
                                <v-list-item v-if="group.id > 0" class="pl-2" @click="changeGroupV2('rs', item, group.id)" role="menuitemradio" :aria-checked="String(item.group_id === group.id)">
                                    <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                    <v-list-item-title>{{ group.name }}</v-list-item-title>
                                </v-list-item>
                            </div>

                            <v-list-item class="pl-2" @click="changeAccess('rs', item)" role="menuitemradio" :aria-checked="String(!item.research_suite)">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>No Access</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

                <!-- Content Suite -->
                <template class="px-0" v-slot:item.content_suite_group_id="{ item }">
                    <v-menu top offset-y right content-class="submenu" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small text rounded color="grey darken-2" outlined type="button" aria-haspopup="menu">
                                <span v-if="item.admin">admin</span>
                                <span v-else-if="!item.content_suite">no access</span>
                                <span v-else>
                                    {{ cs_groups[cs_groups.findIndex((x) => item.content_suite_group_id == x.id)].name }}
                                </span>
                                <v-icon size="16px" aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list rounded dense style="max-height: 300px; overflow-y: auto; font-weight: bold !important" role="menu" aria-label="Content Suite group">
                            <v-list-item class="pl-2" @click="grantAdmin(item)" role="menuitemradio" :aria-checked="String(Boolean(item.admin))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>

                            <div v-for="group in cs_groups" :key="group.id">
                                <v-list-item
                                    v-if="group.id > 0"
                                    class="pl-2"
                                    @click="changeGroupV2('cs', item, group.id)"
                                    role="menuitemradio"
                                    :aria-checked="String(item.content_suite_group_id === group.id)">
                                    <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                    <v-list-item-title>{{ group.name }}</v-list-item-title>
                                </v-list-item>
                            </div>

                            <v-list-item class="pl-2" @click="changeAccess('cs', item)" role="menuitemradio" :aria-checked="String(!item.content_suite)">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>No Access</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

                <!-- Monitoring Suite -->
                <template class="px-0" v-slot:item.monitoring_suite_group_id="{ item }">
                    <v-menu top offset-y right content-class="submenu" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small text rounded color="grey darken-2" outlined type="button" aria-haspopup="menu">
                                <span v-if="item.admin">admin</span>
                                <span v-else-if="!item.monitoring_suite">no access</span>
                                <span v-else>
                                    {{ ms_groups[ms_groups.findIndex((x) => item.monitoring_suite_group_id == x.id)].name }}
                                </span>
                                <v-icon size="16px" aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list rounded dense style="max-height: 300px; overflow-y: auto; font-weight: bold !important" role="menu" aria-label="Monitoring Suite group">
                            <v-list-item class="pl-2" @click="grantAdmin(item)" role="menuitemradio" :aria-checked="String(Boolean(item.admin))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>

                            <div v-for="group in ms_groups" :key="group.id">
                                <v-list-item
                                    v-if="group.id > 0"
                                    class="pl-2"
                                    @click="changeGroupV2('ms', item, group.id)"
                                    role="menuitemradio"
                                    :aria-checked="String(item.monitoring_suite_group_id === group.id)">
                                    <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                    <v-list-item-title>{{ group.name }}</v-list-item-title>
                                </v-list-item>
                            </div>

                            <v-list-item class="pl-2" @click="changeAccess('ms', item)" role="menuitemradio" :aria-checked="String(!item.monitoring_suite)">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>No Access</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

                <!-- KI Chat -->
                <template class="px-0" v-slot:item.ki_chat="{ item }">
                    <v-menu top offset-y right content-class="submenu" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small text rounded color="grey darken-2" outlined type="button" aria-haspopup="menu">
                                <span v-if="item.admin">admin</span>
                                <span v-else-if="!item.ki_chat">no access</span>
                                <span v-else>Access</span>
                                <v-icon size="16px" aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list rounded dense style="max-height: 300px; overflow-y: auto; font-weight: bold !important" role="menu" aria-label="KI Chat access">
                            <v-list-item class="pl-2" @click="grantAdmin(item)" role="menuitemradio" :aria-checked="String(Boolean(item.admin))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>

                            <v-list-item class="pl-2" @click="changeAccess('ki_chat', item, 1)" role="menuitemradio" :aria-checked="String(Boolean(item.ki_chat))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Access</v-list-item-title>
                            </v-list-item>

                            <v-list-item class="pl-2" @click="changeAccess('ki_chat', item, 0)" role="menuitemradio" :aria-checked="String(!item.ki_chat)">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>No Access</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

                <!-- KI Suite -->
                <template class="px-0" v-slot:item.ki_suite="{ item }">
                    <v-menu top offset-y right content-class="submenu" :close-on-content-click="true">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" small text rounded color="grey darken-2" outlined type="button" aria-haspopup="menu">
                                <span v-if="item.admin">admin</span>
                                <span v-else-if="!item.ki_suite">no access</span>
                                <span v-else>{{ ksGroupName(item) }}</span>
                                <v-icon size="16px" aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>

                        <v-list rounded dense style="max-height: 300px; overflow-y: auto; font-weight: bold !important" role="menu" aria-label="KI Suite group">
                            <v-list-item class="pl-2" @click="grantAdmin(item)" role="menuitemradio" :aria-checked="String(Boolean(item.admin))">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>Admin</v-list-item-title>
                            </v-list-item>

                            <div v-for="group in ks_groups" :key="group.id">
                                <v-list-item
                                    v-if="group.id > 0"
                                    class="pl-2"
                                    @click="changeGroupV2('ks', item, group.id)"
                                    role="menuitemradio"
                                    :aria-checked="String(Boolean(item.ki_suite) && Number(item.ki_suite_group_id) === group.id)">
                                    <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                    <v-list-item-title>{{ group.name }}</v-list-item-title>
                                </v-list-item>
                            </div>

                            <v-list-item class="pl-2" @click="changeAccess('ks', item, 0)" role="menuitemradio" :aria-checked="String(!item.ki_suite)">
                                <v-icon color="primary" class="mr-2" aria-hidden="true">mdi-circle-outline</v-icon>
                                <v-list-item-title>No Access</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>

                <template class="px-0" v-slot:item.verification_status_translated="{ item }">
                    <center>
                        <v-icon color="primary" v-if="item.verification_status == 1" aria-hidden="true">mdi-check-circle-outline</v-icon>
                        <v-icon color="errorred" v-else aria-hidden="true">mdi-close-circle-outline</v-icon>
                        <span class="sr-only">
                            {{ item.verification_status == 1 ? "Verified" : "Not verified" }}
                        </span>
                    </center>
                </template>

                <template class="px-0" v-slot:item.action="{ item }">
                    <v-menu offset-y rounded="lg" color="primary" transition="slide-y-transition" bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark rounded outlined small v-bind="attrs" v-on="on" type="button" aria-haspopup="menu">
                                <v-icon small aria-hidden="true">mdi-account-edit</v-icon>
                                <v-icon aria-hidden="true">mdi-chevron-down</v-icon>
                            </v-btn>
                        </template>
                        <v-list rounded dense role="menu" aria-label="User actions">
                            <v-list-item @click="openDeleteDialog(item)" role="menuitem">
                                <v-icon class="mr-2" aria-hidden="true">mdi-delete-circle</v-icon>
                                <v-list-item-title>Delete User</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="item.verification_status == 0" @click="resendVerificationMail(item)" role="menuitem">
                                <v-icon class="mr-2" aria-hidden="true">mdi-send-circle-outline</v-icon>
                                <v-list-item-title>Resend verification mail</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </div>
    </div>
</template>

<script>
    import AddUserDialog from "../dialogs/AddUserDialog"

    export default {
        name: "UserTable",
        components: { AddUserDialog },
        props: {
            domains: Array
        },
        data() {
            return {
                user_sort_by: ["username"],
                user_sort_desc: [false],
                showDefaultGroup: false,
                info: {
                    message: null,
                    icon: null,
                    color: null
                },
                showInfo: false,
                auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
                changeGroupDialog: false,
                deleteDialog: false,
                content_suite_allowed: false,
                deleteUserQuestion: false,
                showchangeMessage: false,
                changeMessage: "User Group was successfully changed!",
                selectedUser: {
                    username: ""
                },
                addUserDisabled: true,
                addUserDialog: false,
                search: "",
                newgroup: null,
                selected_standard_group: {},
                selected_standard_group_cs: {},
                selected_standard_group_ms: {},
                selected_standard_group_ki_chat: {},
                selected_standard_group_ks: {},
                groups: [],
                cs_groups: [],
                ms_grous: [],
                ki_chat_groups: [
                    { id: 0, name: "No Access", description: "User has no access to the KI Chat" },
                    { id: 1, name: "Access", description: "User has access to the KI Chat" }
                ],
                // Gruppen 1 (voll) und 2 (nur lesen) werden in fetchGroups mit den Namen der Monitoring-Gruppen überschrieben,
                // damit die Bezeichnungen zu den anderen Suites passen; "No Access" (0) bleibt am Ende
                ks_groups: [
                    { id: 1, name: "Full access", description: "User has full access to the AI Suite" },
                    { id: 2, name: "Read only", description: "User can view the AI Suite but not change anything" },
                    { id: 0, name: "No Access", description: "User has no access to the AI Suite" }
                ],
                user: [],
                header: [
                    {
                        text: "NAME",
                        align: "start",
                        sortable: true,
                        value: "username"
                    },
                    // {
                    //     text: "COMPANY ADMIN",
                    //     align: "start",
                    //     sortable: false,
                    //     value: "admin"
                    // },
                    {
                        text: "RESEARCH SUITE",
                        align: "start",
                        sortable: false,
                        value: "group_id"
                    },
                    {
                        text: "CONTENT SUITE",
                        align: "start",
                        sortable: false,
                        value: "content_suite_group_id"
                    },
                    {
                        text: "MONITORING SUITE",
                        align: "start",
                        sortable: false,
                        value: "monitoring_suite_group_id"
                    },
                    {
                        text: "AI SUITE",
                        align: "start",
                        sortable: false,
                        value: "ki_suite"
                    },
                    {
                        text: "KI CHAT",
                        align: "start",
                        sortable: false,
                        value: "ki_chat"
                    },
                    // {
                    //     text: "GROUP",
                    //     align: "start",
                    //     sortable: false,
                    //     value: "group_name"
                    // },
                    {
                        text: "MAIL VERIFICATED",
                        align: "center",
                        sortable: false,
                        value: "verification_status_translated"
                    },
                    {
                        text: "",
                        align: "end",
                        sortable: false,
                        value: "action"
                    }
                ]
            }
        },
        computed: {
            usersResultsCount() {
                if (!this.search) return (this.user || []).length
                const s = String(this.search).toLowerCase()
                return (this.user || []).filter((u) => (u.username || "").toLowerCase().includes(s) || (u.user || "").toLowerCase().includes(s)).length
            },
            usersStatusText() {
                if (!this.search) return `${(this.user || []).length} users`
                const n = this.usersResultsCount
                return `${n} user${n === 1 ? "" : "s"} for “${this.search}”`
            },
            lutz() {
                return this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8) == 32
            },
            company_status_cs() {
                return this.$store.state.company_status_content_suite
            },
            company_status_ms() {
                return this.$store.state.company_status_monitoring_suite
            },
            company_status_ki_chat() {
                return this.$store.state.company_status_ki_chat
            },
            company_status_ki_suite() {
                return this.$store.state.company_status_ai_suite
            }
        },
        methods: {
            async getStandardGroup() {
                try {
                    const url = process.env.VUE_APP_APIURL + "/company/standardgroup/get"
                    let post_data = {
                        company_id: localStorage.company_id
                    }
                    let answer = await this.$helpers.axiosPost(url, post_data)
                    console.log(this.cs_groups.findIndex((x) => x.id == answer.data.standard_group_cs))
                    console.log(this.cs_groups)
                    console.log(this.ms_groups)

                    // 0 == no access
                    this.selected_standard_group = this.groups[this.groups.findIndex((x) => x.id == answer.data.standard_group)]
                    this.selected_standard_group_cs = this.cs_groups[this.cs_groups.findIndex((x) => x.id == answer.data.standard_group_cs)]
                    this.selected_standard_group_ms = this.ms_groups[this.ms_groups.findIndex((x) => x.id == answer.data.standard_group_ms)]
                    this.selected_standard_group_ki_chat = this.ki_chat_groups[this.ki_chat_groups.findIndex((x) => x.id == answer.data.standard_group_ki_chat)]
                    // nie gesetzt (NULL) == No Access, sonst bricht changeStandardGroup an .id ab
                    this.selected_standard_group_ks = this.ks_groups.find((x) => x.id == answer.data.standard_group_ki_suite) || this.ks_groups.find((x) => x.id === 0)
                    console.log("HEEEERE", this.selected_standard_group_cs)
                } catch (error) {
                    console.log(error)
                }
            },
            async changeStandardGroup() {
                console.log(this.selected_standard_group)
                console.log(this.selected_standard_group_ms) // neu
                console.log(this.selected_standard_group_cs.id) // neu

                //TODO: api funktion anapssen und neue Rechte übergeben
                try {
                    const url = process.env.VUE_APP_APIURL + "/company/standardgroup/switch"
                    let post_data = {
                        company_id: localStorage.company_id,
                        group: this.selected_standard_group.id,
                        group_cs: this.selected_standard_group_cs.id,
                        group_ms: this.selected_standard_group_ms.id,
                        group_ki_chat: this.selected_standard_group_ki_chat.id,
                        group_ks: this.selected_standard_group_ks.id
                    }
                    await this.$helpers.axiosPost(url, post_data)
                } catch (error) {
                    console.log(error)
                }
            },
            async changeAccess(suite, item, value = undefined) {
                let logout_user = true
                if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                    logout_user = false
                }
                let url = process.env.VUE_APP_APIURL + "/user/suite/switch"
                let post_data = {
                    id: item.id,
                    status_new: suite == "rs" ? (item.research_suite == 0 ? 1 : 0) : suite == "cs" ? (item.content_suite == 0 ? 1 : 0) : suite == "ms" ? (item.monitoring_suite == 0 ? 1 : 0) : value,
                    logout_user: logout_user,
                    suite: suite
                }
                let response = await this.$helpers.axiosPost(url, post_data)
                console.log("STATUS NEW: ", post_data.status_new)
                console.log(this.user[this.user.findIndex((x) => x.id == item.id)])
                console.log(
                    this.user[this.user.findIndex((x) => x.id == item.id)][
                        suite == "rs" ? "research_suite" : suite == "cs" ? "content_suite" : suite == "ms" ? "monitoring_suite" : suite == "ki_chat" ? "ki_chat" : "ki_suite"
                    ]
                )
                let userindex = this.user.findIndex((x) => x.id == item.id)
                if (userindex > -1) {
                    this.user[userindex][suite == "rs" ? "research_suite" : suite == "cs" ? "content_suite" : suite == "ms" ? "monitoring_suite" : suite == "ki_chat" ? "ki_chat" : "ki_suite"] =
                        post_data.status_new
                    this.user[userindex].admin = 0
                }

                if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                    this.$store.dispatch("FETCH_STARTUP_DATA", item.user)
                }
                console.log(response)
                this.showchangeMessage = true
            },
            async grantAdmin(item) {
                let logout_user = true
                if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                    logout_user = false
                }
                let url = process.env.VUE_APP_APIURL + "/user/admin/switch"
                let post_data = {
                    id: item.id,
                    logout_user: logout_user,
                    new_status: 1
                }
                let response = await this.$helpers.axiosPost(url, post_data)
                console.log(this.user.findIndex((x) => x.id == item.id))
                let userindex = this.user.findIndex((x) => x.id == item.id)
                if (userindex > -1) {
                    this.user[userindex].admin = 1
                    this.user[userindex].research_suite = 1
                    this.user[userindex].content_suite = 1
                    this.user[userindex].monitoring_suite = 1
                    this.user[userindex].ki_chat = 1
                    this.user[userindex].ki_suite = 1
                }

                if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                    this.$store.dispatch("FETCH_STARTUP_DATA", item.user)
                }
                console.log(response)
                this.showchangeMessage = true
            },
            createInfo(message, color, icon) {
                this.info.message = message
                this.info.color = color
                this.info.icon = icon
                this.showInfo = true
            },
            resendVerificationMail(item) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/user/verificate/mail", { email: item.user }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        if (response.status == 200) {
                            this.createInfo("Email has been resent. The user should receice an email with an activation-link!", "green", "mdi-check-circle-outline")
                        } else {
                            this.createInfo("There went something wrong. Please contact the support!", "#fcba03", "mdi-alert-circle-outline")
                        }
                    })
                    .catch((error) => {
                        this.createInfo("There went something wrong. Please contact the support!", "#fcba03", "mdi-alert-circle-outline")
                    })
            },
            openDeleteDialog(item) {
                this.selectUser(item)
                this.deleteUserQuestion = true
            },
            openGroupDialog(item) {
                this.selectUser(item)
                this.changeGroupDialog = true
            },
            changeGroupV2(suite, item, id) {
                let logoutUser = true
                if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                    logoutUser = false
                }
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/user/group/switch", { id: item.id, group_id: id, logoutUser: logoutUser, suite: suite }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        if (item.id == this.CryptoJS.AES.decrypt(localStorage.id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) {
                            this.$store.dispatch("FETCH_STARTUP_DATA", item.user)
                        }
                        // this.changeGroupDialog = false
                        // this.fetchUser()
                        let userindex = this.user.findIndex((x) => x.id == item.id)
                        if (userindex > -1) {
                            this.user[userindex][suite == "rs" ? "group_id" : suite == "cs" ? "content_suite_group_id" : suite == "ks" ? "ki_suite_group_id" : "monitoring_suite_group_id"] = id
                            this.user[userindex][suite == "rs" ? "research_suite" : suite == "cs" ? "content_suite" : suite == "ks" ? "ki_suite" : "monitoring_suite"] = 1
                            this.user[userindex].admin = 0
                            // if author, change rs and ms to false
                            if (suite == "cs" && id == 2) {
                                this.user[userindex].research_suite = 0
                                this.user[userindex].monitoring_suite = 0
                            }
                        }

                        console.log(this.user)
                        this.showchangeMessage = true
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            selectUser(userrow) {
                this.selectedUser = userrow
            },
            // Anzeigename der AI-Suite-Gruppe eines Users; ohne gespeicherte Gruppe (Spalte neu) gilt voller Zugriff
            ksGroupName(item) {
                const group = this.ks_groups.find((x) => x.id === Number(item.ki_suite_group_id)) || this.ks_groups.find((x) => x.id === 1)
                return group ? group.name : "Access"
            },
            deleteUser() {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/user/deleteone", { id: this.selectedUser.id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        this.deleteUserQuestion = false
                        this.fetchUser()
                        this.createInfo("The selected user has been deleted!", "green", "mdi-check-circle-outline")
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            fetchUser() {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/user/companyuser", { company_id: localStorage.company_id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        console.log(response)
                        // let admins = response.body.filter((x) => x.group_id == 1)
                        // let cs_allowed_admins = admins.filter((x) => x.content_suite)
                        // if (cs_allowed_admins.length) this.content_suite_allowed = true
                        this.fetchGroups(response.body)
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },

            fetchGroups(users) {
                this.$http
                    .post(process.env.VUE_APP_APIURL + "/rights/groups/company", { company_id: localStorage.company_id }, { headers: { Authorization: this.auth } })
                    .then((response) => {
                        let mappedUser = users.map((x) => {
                            if (x.verification_status == 1) {
                                x.verification_status_translated = "yes"
                            } else {
                                x.verification_status_translated = "no"
                            }
                            return x
                        })

                        //hide admin accounts in customer databases
                        if (parseInt(this.CryptoJS.AES.decrypt(localStorage.company_id, process.env.VUE_APP_ENCRYPTION_PW).toString(this.CryptoJS.enc.Utf8)) > 2) {
                            this.user = mappedUser.filter((x) => x.id > 4)
                        } else {
                            this.user = mappedUser
                        }

                        // let mappedGroups = response.body.standard_groups.map((x) => {
                        //     // console.log(x)
                        //     let obj = {}
                        //     obj.text = x.name
                        //     obj.value = x.id
                        //     obj.description = x.description
                        //     return obj
                        // })

                        //remove when guest role should appear
                        // mappedGroups.length = 5
                        let obj = {
                            name: "No Access",
                            id: 0,
                            description: "Cant see or access this suite."
                        }

                        this.groups = response.body.standard_groups
                        this.groups.push(obj)

                        console.log(this.groups)
                        // filter author from cs groups
                        this.cs_groups = response.body.cs_groups
                        this.cs_groups.push(obj)
                        // .filter((x) => x.id !== 2)
                        this.ms_groups = response.body.ms_groups
                        this.ms_groups.push(obj)
                        // AI Suite: dieselben Gruppen wie Monitoring, aber nur 1 (voll) und 2 (nur lesen) - kein Author o. Ä.
                        const ksBase = this.ms_groups.filter((x) => x.id === 1 || x.id === 2)
                        if (ksBase.length === 2) this.ks_groups = ksBase.concat([obj])

                        this.getStandardGroup()
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            hideColumns() {
                if (this.company_status_cs !== "active" && this.company_status_cs !== "testing" && this.company_status_cs !== "free") {
                    this.header.splice(
                        this.header.findIndex((x) => x.value == "content_suite_group_id"),
                        1
                    )
                }
                if (this.company_status_ms !== "active" && this.company_status_ms !== "testing" && this.company_status_ms !== "free") {
                    this.header.splice(
                        this.header.findIndex((x) => x.value == "monitoring_suite_group_id"),
                        1
                    )
                }
                if (this.company_status_ki_chat !== "active" && this.company_status_ki_chat !== "testing" && this.company_status_ki_chat !== "free") {
                    this.header.splice(
                        this.header.findIndex((x) => x.value == "ki_chat"),
                        1
                    )
                }
                if (this.company_status_ki_suite !== "active" && this.company_status_ki_suite !== "testing" && this.company_status_ki_suite !== "free") {
                    console.log("remove ki suite")
                    this.header.splice(
                        this.header.findIndex((x) => x.value == "ki_suite"),
                        1
                    )
                }
            }
            // fetchCsStatus() {
            //     this.$http
            //         .post(process.env.VUE_APP_APIURL + "/cs/status", { company_id: localStorage.company_id }, { headers: { Authorization: this.auth } })
            //         .then((response) => {
            //             console.log(response)
            //             console.log(response.body.cs_allowed)
            //             this.content_suite_allowed = response.body.cs_allowed
            //         })
            //         .catch((err) => {
            //             console.log(err)
            //         })
            // }
        },
        mounted() {
            this.hideColumns()
            if (this.lutz) {
                let headerIndex = this.header.findIndex((e) => e.value == "monitoring_suite_group_id")
                if (headerIndex > -1) this.header[headerIndex].text = "QUICK SEO"
            }
            // this.fetchCsStatus()
            this.fetchUser()
        }
    }
</script>
<style>
    #usertable th {
        font-weight: 500;
        letter-spacing: 0.0892857143em;
        white-space: nowrap;
    }
</style>
